<template>
  <div v-if="action != ServiceCallActions.None">
    <carousel
      class="card__wrapper"
      :items-to-show="1"
      v-if="carouselData.length > 0"
      ref="myCarousel"
      v-model="currentIndex"
      :wrapAround="true"
      :mouseDrag="false"
      :dir="language.dir"
    >
      <slide v-for="(item, slide) in carouselData" :key="slide">
        <local-image
          :item="item"
          :allImages="allImages"
          v-if="action == ServiceCallActions.Image"
          @reload="getData"
          :newImageID="newImageID"
          :newImage="newImage"
        ></local-image>
        <local-money
          :data="item"
          v-if="action == ServiceCallActions.Money"
          @reload="getData"
        ></local-money>
        <local-problem-sub
          v-if="action == ServiceCallActions.ProblemSub"
          :data="item"
          @reload="getData"
        ></local-problem-sub>
      </slide>
      <template #addons="{ slidesCount }">
        <navigation v-if="slidesCount > 1" />
      </template>
    </carousel>

    <div v-else>
      <span v-if="action == ServiceCallActions.Image">
        {{ __("No photos were attached for this reading") }}
      </span>
      <span v-if="action == ServiceCallActions.Money">
        {{ __("No expenses were found for this reading") }}
      </span>
      <span v-if="action == ServiceCallActions.ProblemSub">
        {{ __("There are no updates for this call") }}
      </span>
    </div>
    <local-srvice-call-data
      v-if="action == ServiceCallActions.View"
      :serviceCall="serviceCall"
      @DeleteServiceCall="$emit('DeleteServiceCall', $event)"
    ></local-srvice-call-data>
    <div class="p-d-flex p-jc-between p-ai-center">
      <div>
        <span v-if="carouselData.length > 1">
          {{ currentIndex + 1 }}/{{ carouselData.length }}</span
        >
      </div>
      <div class="p-d-flex p-jc-end" style="gap: 10px;">
        <p-vue-button
          icon="pi pi-check"
          class="p-button-rounded p-button-success p-button-outlined"
          @click="changeItemKey('SaveEditData')"
          v-if="carouselData.length > 0 && carouselData[currentIndex]?.IsEdit"
        />
        <p-vue-button
          icon="pi pi-pencil"
          class="p-button-rounded p-button-success p-button-outlined"
          @click="changeItemKey('IsEdit')"
          v-if="carouselData.length > 0 && !carouselData[currentIndex]?.IsEdit"
        />
        <p-vue-button
          v-if="
            carouselData.length > 0 &&
              ((action == ServiceCallActions.ProblemSub &&
                allowDeleteProblemSub) ||
                action != ServiceCallActions.ProblemSub)
          "
          icon="pi pi-trash"
          class="p-button-rounded p-button-danger p-button-outlined"
          @click="confirmDelete"
        />
        <p-vue-button
          icon="pi pi-plus"
          v-if="
            action == ServiceCallActions.Image ||
              action == ServiceCallActions.Money ||
              action == ServiceCallActions.ProblemSub
          "
          class="p-button-rounded p-button-success p-button-outlined"
          @click="addData"
        />
      </div>
    </div>
    <i-override-dialog
      v-model:visible="showModel"
      :style="{
        width: '100%',
        maxWidth: 'calc(100vw - 10px)',
      }"
      :modal="true"
      :dismissableMask="true"
      :title="__(addModelTitle) + ' ' + PID"
    >
      <local-add-problem-sub
        v-if="action == ServiceCallActions.ProblemSub"
        :PID="serviceCall.PID"
        @addProblemSub="addProblemSub"
        :close="
          () => {
            showModel = false;
          }
        "
      ></local-add-problem-sub>
      <local-add-money
        v-if="action == ServiceCallActions.Money"
        :money="moneyBase"
        @moneyChanged="moneyChanged"
        :close="
          () => {
            showModel = false;
          }
        "
      ></local-add-money>
      <local-add-service-call
        :serviceCall="serviceCall"
        :close="
          () => {
            showModel = false;
            $emit('changeAction', ServiceCallActions.None);
          }
        "
        v-if="action == ServiceCallActions.Edit"
        @serviceCallChanged="serviceCallChanged"
      ></local-add-service-call>
    </i-override-dialog>
  </div>

  <p-get-image v-if="getImage" @getImage="getPictureLocal"></p-get-image>
</template>

<script>
import { ServiceCallActions } from "@/configs/enums";
import LocalImage from "./image";
import LocalMoney from "./money";
import LocalAddMoney from "./add-money";
import LocalProblemSub from "./problem-sub";
import LocalAddProblemSub from "./add-problem-sub";
import LocalAddServiceCall from "./add-service-call";
import LocalSrviceCallData from "./srvice-call-data";
import PGetImage from "@/components/partials/p-get-image";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { getPicture } from "@/services/UploadFilesService";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import { __ } from "@/plugins/i18n/";
import { mapState } from "vuex";
import { UploadServiceCallImageUrl } from "@/services/cloudflareUploaderService";

export default {
  components: {
    PGetImage,
    LocalImage,
    LocalMoney,
    LocalAddMoney,
    LocalProblemSub,
    LocalAddProblemSub,
    LocalAddServiceCall,
    LocalSrviceCallData,
    Carousel,
    Slide,
    Navigation,
  },
  props: {
    serviceCall: {
      type: Object,
    },
  },
  emits: ["DeleteServiceCall", "changeAction", "refreshServiceCall"],
  data() {
    return {
      ServiceCallActions,
      serviceCallLocal: {},
      carouselData: [],
      showModel: false,
      addModelTitle: "Add",
      allowDeleteProblemSub: 0,
      customCarouselHideOne: "",
      newImage: null,
      getImage: false,
      modelValue: null,
      currentIndex: 0,
      allImages: [1, 2, 3],
      lastIndex: 0,
      newImageID: 0,
    };
  },
  mounted() {
    this.serviceCallLocal = this.serviceCall;
  },
  methods: {
    getData(procName, reload = false) {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("PID", this.PID, apiPType.Int)];
      callProc(procName, procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log(procName, result);
          this.carouselData.map((row) => {
            row.IsEdit = false;
            row.Delete = false;
            row.SaveEditData = false;
          });
          if (!reload) {
            this.carouselData = result.Table;
            this.currentIndex = 0;
          } else {
            this.carouselData.forEach((obj, idx) => {
              this.carouselData[idx] = result.Table[idx];
            });
          }

          if (this.action == ServiceCallActions.ProblemSub) {
            this.allowDeleteProblemSub =
              result.Table1[0].AllowProblemsDeleteThroughApp;
            this.serviceCallLocal.problemsSubCnt = this.carouselData.length;
          } else if (this.action == ServiceCallActions.Money) {
            this.carouselData.forEach((data) => {
              data.Items = result.Table1.filter((f) => f.TRID == data.TRID);
            });
            this.serviceCallLocal.moneyCnt = this.carouselData.length;
            if (this.showModel) {
              this.showModel = false;
              setTimeout(() => {
                this.currentIndex = this.carouselData.length - 1;
              }, 1000);
            }
          } else if (this.action == ServiceCallActions.Image) {
            this.allImages = this.carouselData;
            this.serviceCallLocal.imgCnt = this.carouselData.length;
          }
          this.customCarouselHideOne =
            result.Table.length > 1 ? "" : "custom-carousel-hide-one";
          this.$store.dispatch("doLoading", false);
          this.$emit("refreshServiceCall", this.serviceCallLocal);
          setTimeout(() => {
            // console.log("window.dudi = this.$refs.myCarousel;");
            window.dudi = this.$refs.myCarousel;
          }, 1500);
        })
        .catch(() => {
          errorReceived("getData(procName, reload = false) {");
        });
    },
    addData() {
      if (
        this.action == ServiceCallActions.Money ||
        this.action == ServiceCallActions.ProblemSub
      ) {
        this.addModelTitle = "Add " + this.whatAdd;
        this.showModel = true;
      } else if (this.action == ServiceCallActions.Image) this.addImage();
    },
    addImage() {
      this.getImage = false;
      this.newImage = null;
      this.newImageID = 0;
      setTimeout(() => {
        this.getImage = true;
      }, 0);
    },
    getPictureLocal(sourceType) {
      getPicture(sourceType, (obj) => {
        this.getImage = false;
        this.newImage = obj;
        this.saveImage();
      });
    },
    saveImage() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("PID", this.PID, apiPType.Int),
        apiParam("FileEXT", "JPEG", apiPType.NVarChar),
        apiParam("Subject", null, apiPType.NVarChar),
        apiParam("createBy", this.userNum, apiPType.Int),
      ];
      callProc("TennatApp_CreateNewFile", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.newImageID = result.Table[0].ImgID;
          this.upload(
            this.newImage,
            this.newImageID,
            this.PID + ".jpeg",
            result.Table[0]
          );
        })
        .catch(() => {
          errorReceived("TennatApp_CreateNewFile");
        });
    },
    upload(file, FileId, srcFileName, imageRow) {
      UploadServiceCallImageUrl(FileId, file, srcFileName)
        .then((response) => {
          this.$store.dispatch("doLoading", false);
          if (response === true) {
            this.getData("WorkerApp_GetImagesToServiceCall");
            imageRow.PathImg = imageRow.PathImgEnc;
            // this.carouselData.push(imageRow);
            this.serviceCallLocal.imgCnt++;
            setTimeout(() => {
              this.currentIndex = this.carouselData.length - 1;
            }, 100);
            showSuccessOrFailedModal(__("Image saved successfully"));
          } else {
            showSuccessOrFailedModal(
              __("There was an error saving the image"),
              false
            );
          }
        })
        .catch((e) => {
          console.log(e);
          this.uploadProgress = 0;
        });
    },
    serviceCallChanged(serviceCall) {
      this.showModel = false;
      this.$emit("changeAction", ServiceCallActions.None);
      this.$emit("refreshServiceCall", serviceCall);
    },
    moneyChanged(reload) {
      this.getData("WorkerApp_GetMoneyToServiceCall", reload);
    },
    addProblemSub(problemSub) {
      this.carouselData.push(problemSub);
      setTimeout(() => {
        this.currentIndex = this.carouselData.length - 1;
      }, 100);
      this.serviceCallLocal.problemsSubCnt = this.carouselData.length;
      // console.log(this.currentIndex, this.carouselData);
      this.showModel = false;
    },
    changeItemKey(key) {
      this.carouselData[this.currentIndex][key] = true;
    },
    confirmDelete(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: __("Are you sure?"),
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          this.changeItemKey("Delete");
        },
        reject: () => {},
      });
    },
  },
  computed: {
    action() {
      return this.serviceCall.action;
    },
    PID() {
      return this.serviceCall.PID;
    },
    moneyBase() {
      return {
        PID: this.PID,
        BID: this.serviceCall.BID,
        UID: this.serviceCall.UID,
      };
    },
    whatAdd() {
      return this.action == ServiceCallActions.Image
        ? "Picture"
        : this.action == ServiceCallActions.ProblemSub
        ? "update"
        : this.action == ServiceCallActions.Money
        ? "Expense"
        : "Service call";
    },
    ...mapState({
      language: (state) => state.local,
      userNum: (state) => state.api.workerID,
    }),
  },
  watch: {
    action() {
      // console.log("action changed", this.action);
      this.carouselData = [];
      switch (this.action) {
        case ServiceCallActions.Image:
          this.getData("WorkerApp_GetImagesToServiceCall");
          break;
        case ServiceCallActions.Money:
          this.getData("WorkerApp_GetMoneyToServiceCall");
          break;
        case ServiceCallActions.ProblemSub:
          this.getData("WorkerApp_GetProblemsSubToServiceCall");
          break;
        case ServiceCallActions.Edit:
          this.showModel = true;
          this.addModelTitle = "update service call num";
          break;
        // case ServiceCallActions.View:
        //   console.log("view");
        //   break;
      }
    },
    // currentIndex() {
    //   if (!this.currentIndex) this.currentIndex = this.lastIndex;
    //   else this.lastIndex = this.currentIndex;
    // },
  },
};
</script>

<style scoped>
:deep(.p-carousel-item) {
  direction: rtl;
}

:deep(.p-carousel-content) {
  direction: ltr;
}

:deep(.p-carousel .p-carousel-indicators .p-carousel-indicator button) {
  width: 0.5rem;
}

:deep(.custom-carousel-hide-one .p-carousel-content .p-carousel-prev),
:deep(.custom-carousel-hide-one .p-carousel-content .p-carousel-next),
:deep(.custom-carousel-hide-one .p-carousel-content .p-carousel-indicators) {
  display: none;
}

.button {
  width: 100%;
}

:deep(.p-carousel .p-carousel-content .p-carousel-prev, .p-carousel
    .p-carousel-content
    .p-carousel-next) {
  margin: 0;
  width: 0.8rem;
  height: 0.8rem;
}
:deep(.carousel__slide) {
  display: block;
}

.he .card__wrapper {
  text-align: right;
}

.en .card__wrapper {
  text-align: left;
}

:deep(.carousel__prev),
:deep(.carousel__next) {
  background-color: #fff;
  border: 1px solid var(--color-success);
}

:deep(.carousel__icon) {
  fill: var(--color-success);
}
</style>
